import { useState } from "react";
import { WIDGET_LIST, CATEGORIES } from "@/lib/widgets";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Plus, Check } from "lucide-react";
import { cn } from "@/lib/utils";

export function WidgetLibrary({ open, onOpenChange, activeTypes, onAdd }) {
  const [cat, setCat] = useState(CATEGORIES[0]);
  const widgets = WIDGET_LIST.filter((w) => w.category === cat);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full overflow-y-auto scrollbar-thin sm:max-w-md" data-testid="widget-library">
        <SheetHeader>
          <SheetTitle className="font-heading text-2xl">Widget Library</SheetTitle>
          <SheetDescription>Add widgets to your dashboard. All show live or empty data — never sample content.</SheetDescription>
        </SheetHeader>
        <div className="mt-4 flex flex-wrap gap-1.5">
          {CATEGORIES.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`lib-cat-${c.toLowerCase().replace(/\s+/g, "-")}`}
              className={cn("rounded-full px-3 py-1 text-xs font-medium transition-colors",
                cat === c ? "bg-primary text-primary-foreground" : "bg-secondary text-secondary-foreground hover:bg-muted")}>
              {c}
            </button>
          ))}
        </div>
        <div className="mt-4 space-y-2">
          {widgets.map((w) => {
            const Icon = w.icon;
            const added = activeTypes.includes(w.type);
            return (
              <div key={w.type} className="flex items-center gap-3 rounded-lg border border-border p-3" data-testid={`lib-widget-${w.type}`}>
                <span className={cn("flex h-9 w-9 shrink-0 items-center justify-center rounded-lg",
                  w.accent ? "bg-accent-subtle text-accent" : "bg-secondary text-primary")}>
                  <Icon className="h-4 w-4" />
                </span>
                <div className="min-w-0 flex-1">
                  <div className="truncate text-sm font-medium text-foreground">{w.title}</div>
                  <div className="truncate text-xs text-muted-foreground">{w.empty}</div>
                </div>
                <button onClick={() => onAdd(w.type)} disabled={added} data-testid={`add-widget-${w.type}`}
                  className={cn("flex h-8 w-8 items-center justify-center rounded-lg text-sm transition-colors",
                    added ? "bg-muted text-muted-foreground" : "bg-primary text-primary-foreground hover:opacity-90")}>
                  {added ? <Check className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                </button>
              </div>
            );
          })}
        </div>
      </SheetContent>
    </Sheet>
  );
}
